module.exports = __webpack_public_path__ + "img/emoji_47.99d4c54d.png";